import { render, staticRenderFns } from "./AddProductInStock.vue?vue&type=template&id=6546eb77"
import script from "./AddProductInStock.vue?vue&type=script&lang=js"
export * from "./AddProductInStock.vue?vue&type=script&lang=js"
import style0 from "./AddProductInStock.vue?vue&type=style&index=0&id=6546eb77&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports